module.exports = __webpack_public_path__ + "static/media/clutchLogin.81e6ce39.webp";